import moment from 'moment';
import { Loader } from '../Widgets';
import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from "react-redux";
import { Session, Trip } from 'service';
import ArthaGateway from 'service/ArthaGateway';
import { RootState } from 'store/store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarcode, faCircle, faSquareCheck } from '@fortawesome/free-solid-svg-icons';
import { BarcodeScanner, DetectedBarcode, useTorch } from 'react-barcode-scanner'
import 'react-barcode-scanner/polyfill'
import toast, { Toaster } from 'react-hot-toast';

export const Unloading = () => {
    const appdata = useSelector((state: RootState) => state.appdata);
    const [session, setSession] = useState<Session>();
    const [trips, setTrips] = useState<any[]>([]);
    const [trip, setTrip] = useState<Trip>();
    const [tripId, setTripId] = useState<number>(0);
    const [totalPackages, setTotalPackages] = useState<number>(0);
    const [scannedPackages, setScannedPackages] = useState<number>(0);
    const [orderId, setOrderId] = useState<number>(0);
    const [packageNumber, setPackageNumber] = useState<string>('');
    const [screen, setScreen] = useState<string>('selectTrip');
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isTripLoading, setIsTripLoading] = useState<boolean>(false);
    const paymentAmountRef = useRef<null | HTMLInputElement>(null);
    const barcodeRefRef = useRef<null | HTMLInputElement>(null);
    const audioRef = useRef<HTMLAudioElement>(null);

    useEffect(() => {
        if (appdata.profile) {
            setSession(appdata.profile.profile);
        }
    }, [appdata]);

    useEffect(() => {
        if (session) {
            loadTrips();
        }
    }, [session]);

    useEffect(() => {
        setScannedPackages(0);
        setPackageNumber('');
    }, [orderId]);

    useEffect(() => {
        if (tripId > 0) {
            loadTrip(tripId);
        }
    }, [tripId]);

    const loadTrips = () => {
        setIsLoading(true);
        setScreen('selectTrip');
        // trip status 3 = Assigned
        ArthaGateway
            .getTrips("9", 4)
            .then((data) => {
                setTrips(data.entries);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }

    const selectTrip = (trip) => {
        setTripId(trip.id);
        setScreen('selectOrder');
    }

    const loadTrip = (tripId) => {
        setIsTripLoading(true);
        ArthaGateway
            .getTrip(tripId)
            .then((data) => {
                let totalPackages = 0;
                data.details.forEach((detail, index) => {
                    detail.scannedPackages = 0;
                    detail.totalPackages = detail.order.totalPackages;
                    detail.products = [];
                    detail.packages = detail.packages.filter((pack) => pack.status != "Cancelled");
                    detail.packages.reverse();

                    detail.packages.map((pack) => {
                        pack.items.map((item) => {
                            let product = detail.products.find((p) => p.productName === item.product.name);
                            if (!product) {
                                product = {
                                    productName: item.product.name,
                                    quantity: item.quantity,
                                    packages: []
                                };
                                detail.products.push(product);
                            }

                            product.packages.push({
                                packageNumber: pack.voucherNumber,
                                isScanned: false,
                                numberOfProducts: 0
                            });
                        });
                    });
                    totalPackages += detail.order.totalPackages;
                });
                setTotalPackages(totalPackages);
                setScannedPackages(0);

                setTrip(data);
                setIsTripLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }

    const selectOrder = (orderId) => {
        setOrderId(orderId);
    }

    const toggleExapnd = (target) => {
        if (!trip) return;
        trip?.details.map((request) => {
            if (request.id === target.id) {
                request.isExpanded = !request.isExpanded;
            }
            else {
                request.isExpanded = false;
            }
        });
        setTrip({ ...trip });
    }

    const completeUnloading = () => {
        if (!trip) return;

        ArthaGateway
            .unloadOrder(orderId, trip.id)
            .then((data) => {
                setTripId(0);
                loadTrips();
            })
            .catch(error => {
                console.log(error);
            });
    }

    const onBarcodeCaptured = (barcodes: DetectedBarcode[]) => {
        if (!trip) return;            
        if (screen === 'scanBarcode') {
            setScreen('selectOrder');
        }

        setTimeout(() => {
        barcodes.map((barcode) => {            
                handlePackageNumber(barcode.rawValue.trim());
            });
        }, 500);
    }

    const handlePackageNumber = (packageNumber) => {
        packageNumber = packageNumber.replace(/^0+/, '');
        let scanned = false;
        trip?.details.map((detail, index) => {
            if (detail.order.id !== orderId) return;

            detail.products.map((product) => {
                product.packages.map((pack) => {
                    if (pack.packageNumber === packageNumber) {
                        if (!pack.isScanned) {
                            pack.isScanned = true;

                            pack.numberOfProducts = product.quantity;
                            detail.scannedPackages++;

                            const element: any = document.getElementById("p_" + packageNumber);
                            var elementPosition = element.getBoundingClientRect().top;
                            var offsetPosition = elementPosition + window.pageYOffset - 150;

                            window.scrollTo({
                                top: offsetPosition,
                                behavior: "smooth"
                            });

                            if (barcodeRefRef && barcodeRefRef.current) {
                                barcodeRefRef.current.focus();
                            }

                            element.className = 'card col-3 col-md-1 mb-1 p-0 blinking-text';
                            setInterval(() => {
                                element.className = 'card col-3 col-md-1 mb-1 p-0';
                            }, 4000);

                            setScannedPackages(scannedPackages + 1);
                            let audioToPlay = (!product.aliasName || product.aliasName.trim().length === 0) ? product.productName : product.aliasName;
                            if(pack.numberOfProducts < product.itemsPerPackage) {
                                audioToPlay = "Partial package, "+ pack.numberOfProducts.toString() + " peice of" + audioToPlay;
                            }

                            playAudio(audioToPlay);
                            scanned = true;
                        }
                        else {
                            toast.error('Package already scanned');
                            let audioToPlay = "Rescanned, ";
                            if (!product.aliasName || product.aliasName.trim().length === 0) {
                                audioToPlay += product.productName;
                            } else {
                                audioToPlay += product.aliasName;
                            }
                            playAudio(audioToPlay);
                            return;
                        }
                    }
                });
            });
        });
        if (!scanned) {
            setPackageNumber('');
            //toast.error('Invalid package scanned');
            audioRef?.current?.play();
        }
        else {
            setPackageNumber('');
        }
    }

    const playAudio = (textToPlay) => {
        const speechSynth = window.speechSynthesis;
        if (textToPlay.trim().length) {
            let voices = speechSynthesis.getVoices();
            let indianVoice = voices.find((voice) => voice.lang === 'kn-IN');
            if (!indianVoice) {
                indianVoice = voices.find((voice) => voice.lang === 'hi-IN');
            }
            const newUtter =
                new SpeechSynthesisUtterance(textToPlay);
            if (indianVoice) {
                newUtter.voice = indianVoice;
                newUtter.lang = 'hi-IN';
            }
            speechSynth.speak(newUtter);
        }
    }

    const handlePackage = () => {
        if (!trip) return;
        handlePackageNumber(packageNumber);
    }

    const currencyFormat = (value) =>
        new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR'
        }).format(value);

    return (
        <div className='page page-accounts'>
            <div><Toaster /></div>
            <audio id="alarm_sound" ref={audioRef} src="alarm.mp3" preload="auto"></audio>
            {isLoading &&
                <Loader />
            }
            {!isLoading &&
                <>
                    {screen === 'selectTrip' &&
                        <>
                            <h1>Select Trip</h1>
                            <div className='row mt-2'>
                                <div className='col-12'>
                                    <ul className="list-group">
                                        {(!trips || trips.length == 0) &&
                                            <li className="list-group-item"><div className='alert alert-danger w-100'>No trips are assigned to any order, Please refresh again once trips are assigned</div></li>
                                        }
                                        {trips && trips.map((trip) => (
                                            <li className="list-group-item align-items-center" key={trip.id} onClick={() => selectTrip(trip)}>
                                                <div className="float-start">
                                                    <div className="fw-bold">{trip.name}</div>
                                                    <div>No: {trip.voucherNumber}</div>
                                                </div>
                                                <div className="btn btn-sm btn-dark float-end">Select</div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </>
                    }
                    {screen === 'selectOrder' &&
                        <>

                            {trip && orderId > 0 &&
                                <div className='container' style={{ position: "fixed", top: "70px", zIndex: 1000 }}>
                                    <div className='row mt-2 justify-content-center' style={{ marginRight: "1rem" }}>
                                        <div className='col-10 p-0'>
                                            <input type="text" className="form-control w-100" placeholder="Scan barcode"
                                                value={packageNumber}
                                                ref={barcodeRefRef}
                                                onChange={(e) => setPackageNumber(e.target.value)}
                                                onKeyPress={e => { if (e.key === 'Enter') { handlePackage() } }}
                                                autoFocus />
                                        </div>
                                        <div className='col-2 p-0'>
                                            <div className='btn btn-sm btn-light w-100 h-100' style={{ textAlign: "center" }} onClick={() => setScreen('scanBarcode')}>
                                                <FontAwesomeIcon icon={faBarcode} style={{ marginRight: "10px", verticalAlign: "middle" }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className='row' style={{ marginTop: "70px" }}>
                                <div className='col-12'>
                                    <div className='page-header bg-dark' style={{ paddingBottom: "10px" }}>
                                        <div className="fw-bold">{trip?.name}</div>
                                        <div>No: {trip?.voucherNumber}</div>
                                    </div>
                                </div>
                            </div>
                            {isTripLoading &&
                                <Loader />
                            }
                            {!isTripLoading &&
                                <div className='row mt-2'>
                                    <div className='col-12'>
                                        <div className="accordion" id="tripAccordion">
                                            {(!trip || trip.details.length == 0) &&
                                                <div className='alert alert-danger w-100'>No orders are assigned to this trip, Please refresh again once orders are assigned</div>
                                            }
                                            {trip && trip.details.map((detail) => (
                                                <>
                                                    <div className="accordion-item">
                                                        <div className="accordion-header" id={detail.id.toString()}>
                                                            <div className={detail?.isExpanded === true ? "accordion-button active bg-dark" : "accordion-button collapsed"}>
                                                                <div>
                                                                    <div># <span className="fw-bold" style={{ color: "red" }}>{detail.order.voucherNumber}</span></div>
                                                                    <div>
                                                                        {detail.order.partyName}<br />
                                                                        {detail.scannedPackages} of <b>{detail.order.totalPackages}</b> packages scanned
                                                                        {detail.scannedPackages >= detail.order.totalPackages &&
                                                                            <FontAwesomeIcon icon={faSquareCheck} color="green" style={{ marginLeft: "10px" }} />
                                                                        }
                                                                    </div>
                                                                    <div>
                                                                        <div className="btn btn-sm btn-dark" onClick={() => selectOrder(detail.order.id)}>Select</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div id={"b" + detail.id.toString()} className={detail.order.id === orderId ? "accordion-collapse show" : "accordion-collapse collapse"} aria-labelledby={"d" + detail.id.toString()}>
                                                            <div className="accordion-body p-0">
                                                                <div className="list-group">
                                                                    {detail.products.map((product) => (
                                                                        <>
                                                                            <div className="list-group-item">
                                                                                <div className="fw-bold mb-2">
                                                                                    {product.productName}
                                                                                </div>
                                                                                <div className='row'>
                                                                                    {product.packages.map((pack) => (
                                                                                        <div className='card col-3 col-md-1 mb-1 p-0' key={pack.packageNumber} id={"p_" + pack.packageNumber}>
                                                                                            <div className="card-body p-1">
                                                                                                <FontAwesomeIcon icon={pack.isScanned ? faSquareCheck : faCircle} color={pack.isScanned ? "green" : "red"} style={{ marginRight: "10px" }} />
                                                                                                {pack.packageNumber}
                                                                                            </div>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    ))}
                                                                    <div className="list-group-item">
                                                                        <div className="btn btn-sm btn-danger float-start" onClick={() => setScreen('selectTrip')}>Back</div>
                                                                        {detail.order.totalPackages === scannedPackages &&
                                                                            <div className="btn btn-success float-end" onClick={() => completeUnloading()}>Mark as unloaded</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            }
                        </>
                    }
                    {screen === 'scanBarcode' &&
                        <>

                            <div className='row'>
                                <div className='col-12'>
                                    <BarcodeScanner onCapture={(barcodes) => onBarcodeCaptured(barcodes)} onAbort={() => setScreen('selectOrder')} options={{ delay: 1000, formats: ['code_128', 'code_39', 'code_93', 'ean_8', 'ean_13', 'upc_a', 'upc_e'] }} />
                                </div>
                            </div>
                            <div className='row mt-2'>
                                <div className='col-12'>
                                    <div className="btn btn-sm btn-danger float-start" onClick={() => setScreen('selectOrder')}>Back</div>
                                </div>
                            </div>

                        </>
                    }
                </>
            }
        </div >
    );
};